import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#5b4cdb', // Purple
            light: '#7c6eeb',
            dark: '#4a3cb0',
        },
        secondary: {
            main: '#06b6d4', // Cyan
            light: '#22d3ee',
            dark: '#0891b2',
        },
        background: {
            default: '#f5f3ff', // Light lavender background
            paper: 'rgba(255, 255, 255, 0.9)',
        },
        text: {
            primary: '#1e293b',
            secondary: '#64748b',
        },
    },
    typography: {
        fontFamily: '"IBM Plex Sans", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '3.5rem',
            fontWeight: 700,
            lineHeight: 1.2,
            letterSpacing: '0.02em',
            fontFamily: '"IBM Plex Sans", "Helvetica", "Arial", sans-serif',
            '@media (max-width:600px)': {
                fontSize: '2.5rem',
            },
        },
        h2: {
            fontSize: '2.5rem',
            fontWeight: 700,
            lineHeight: 1.3,
            letterSpacing: '0.02em',
            fontFamily: '"IBM Plex Sans", "Helvetica", "Arial", sans-serif',
            '@media (max-width:600px)': {
                fontSize: '2rem',
            },
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 600,
            lineHeight: 1.4,
            letterSpacing: '0.01em',
            fontFamily: '"IBM Plex Sans", "Helvetica", "Arial", sans-serif',
        },
        body1: {
            fontSize: '1.125rem',
            lineHeight: 1.7,
            fontFamily: '"Source Sans 3", "Helvetica", "Arial", sans-serif',
        },
    },
    shape: {
        borderRadius: 16,
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    background: '#ffffff',
                    border: '1px solid rgba(91, 76, 219, 0.1)',
                    boxShadow: '0 2px 8px rgba(91, 76, 219, 0.08)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 8px 24px rgba(91, 76, 219, 0.15)',
                        border: '1px solid rgba(91, 76, 219, 0.2)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    padding: '12px 32px',
                    fontSize: '1rem',
                    borderRadius: 12,
                    transition: 'all 0.3s ease',
                },
                contained: {
                    background: 'linear-gradient(135deg, #5b4cdb 0%, #7c6eeb 100%)',
                    boxShadow: '0 4px 16px rgba(91, 76, 219, 0.3)',
                    color: '#ffffff',
                    '&:hover': {
                        background: '#000000',
                        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.3)',
                        transform: 'translateY(-2px)',
                    },
                },
                outlined: {
                    borderColor: 'rgba(91, 76, 219, 0.5)',
                    color: '#5b4cdb',
                    '&:hover': {
                        borderColor: '#000000',
                        background: 'rgba(0, 0, 0, 0.05)',
                        color: '#000000',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    background: '#ffffff',
                    border: '1px solid rgba(91, 76, 219, 0.1)',
                    boxShadow: '0 2px 8px rgba(91, 76, 219, 0.08)',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    boxShadow: '0 2px 8px rgba(91, 76, 219, 0.08)',
                    borderBottom: '1px solid rgba(91, 76, 219, 0.1)',
                },
            },
        },
    },
});
